import type { TranscriptConnectionErrorType } from 'src/models/TranscriptConnectionState'

export const RECONNECT_BASE_DELAY_MS = 2000
export const RECONNECT_MAX_DELAY_MS = 30000

// 4401/4403 are app-level auth/permission failures (analogous to HTTP 401/403).
export const FATAL_WS_CLOSE_CODE_TO_ERROR: Partial<Record<number, TranscriptConnectionErrorType>> = {
    1003: 'server_error',
    1009: 'server_error',
    1011: 'server_error',
    4401: 'auth_expired',
    4403: 'access_denied',
}

// TODO(LG-1762): WS close code 4200 means rt-broker is intentionally terminating
// this connection for good (no reconnect). It's sent for finished, read-only
// sessions so the server can free resources tied to connections that no longer
// produce transcript updates. This is purely a server-side resource
// optimization — the client-side tab may still be actively viewed. This whole
// mechanism is temporary and may be removed once editing features go live
// (since editors need the WS to stay open after the job finishes).
export const WS_4200_SESSION_ENDED = 4200
